module.exports = __webpack_public_path__ + "img/ic1.ac51887e.png";